/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { mapToPlanActionType } from "~/views/plans/utils";
import { PlanActionBatchData, PlanActionData } from "../../types";

export const mapPlanActionToPlanEntity = (item: PlanActionData) => {
  const {
    __typename: IgnoredTypename,
    resourceGroups,
    resources,
    windowDuration,
    inputParameters,
    notificationGroups,
    name,
    approvalMode,
    ...rest
  } = item;

  return {
    windowDuration: windowDuration.toString(),
    inputParameters: inputParameters ?? [],
    ...item.action,
    ...rest,
    action: item.action,
    approvalMode: approvalMode ?? undefined,
    id: item.id ?? "",
    name: name,
    actionName: item.action.name,
    actionType: mapToPlanActionType(item.action.__typename),
    listId: item.id,
    resourceGroupIds: resourceGroups?.map((group) => group.id),
    resourceIds: resources?.map((resource) => resource.id),
    resourceGroups: resourceGroups?.map((group) => ({
      ...group,
      id: group.id ?? "",
    })),
    resources: resources?.map((resource) => ({
      ...resource,
      id: resource.id ?? "",
    })),
    notificationGroups: notificationGroups?.map((group) => ({
      ...group,
      id: group.id ?? "",
    })),
    batchActions: undefined,
  };
};

export const mapPlanActionBatchToPlanEntity = (item: PlanActionBatchData) => {
  const {
    __typename: IgnoredTypename,
    windowDuration,
    approvalMode,
    ...rest
  } = item;

  return {
    windowDuration: windowDuration.toString(),
    ...rest,
    approvalMode: approvalMode ?? undefined,
    action: undefined,
    name: item.name,
    listId: item.id ?? "",
    id: item.id ?? "",
    runInSequence: false,
    batchActions:
      item.batchActions?.map((batchAction) => {
        const {
          __typename: IgnoredTypenameBatchAction,
          inputParameters,
          ...batchActionRest
        } = batchAction;
        return {
          ...batchActionRest,
          ...batchAction.action,
          action: batchAction.action,
          id: batchAction.id ?? "",
          name: batchAction.name,
          actionName: batchAction.action.name,
          actionType: mapToPlanActionType(batchAction.action.__typename),
          listId: batchAction.id ?? "",
          batchId: item.id ?? "",
          resourceGroupIds: batchAction.resourceGroups?.map(
            (group) => group.id
          ),
          resourceIds: batchAction.resources?.map((resource) => resource.id),
          notificationGroups: batchAction.notificationGroups?.map((group) => ({
            ...group,
            id: group.id ?? "",
          })),
          inputParameters: inputParameters ?? [],
        };
      }) ?? [],
  };
};
